<template>
  <div class="dict">
    <div class="cjh-title">字典</div>

    <div style="padding: 25px">
      <div class="btn-warp">
        <div style="display: flex; algin-item: center">
          <el-select v-model="data_type" placeholder="数据类型" clearable>
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="(item, index) in dictList"
              :key="index"
            ></el-option>
          </el-select>
          <el-button type="primary" @click="handleQuery">查询</el-button>
        </div>
        <el-button type="primary" @click="handleAdd">新增</el-button>
      </div>
      <el-table :data="curTableData" border max-height="560">
        <el-table-column prop="data_type" label="数据类型">
          <template #default="scope">
            {{ formatDict(scope.row) }}
          </template>
        </el-table-column>
        <el-table-column prop="name" label="字典名称"> </el-table-column>
        <el-table-column prop="sort_order" label="排序"> </el-table-column>
        <el-table-column label="操作" width="200">
          <template #default="scope">
            <el-button
              type="primary"
              style="margin-right: 15px"
              @click="handleEdit(scope.row)"
              >编辑</el-button
            >
            <el-popconfirm
              title="确认删除该数据吗？"
              @confirm="handleDel(scope.row)"
            >
              <el-button type="primary" slot="reference">删除</el-button>
            </el-popconfirm>
          </template>
        </el-table-column>
      </el-table>
    </div>
    <el-dialog
      :title="title"
      :visible.sync="dialogVisible"
      width="30%"
      :before-close="handleClose"
    >
      <el-form
        :model="ruleForm"
        ref="ruleForm"
        label-width="100px"
        class="demo-ruleForm"
      >
        <el-form-item label="数据类型" v-if="dialogVisible" prop="data_type" :rules="btRules">
          <el-select
            v-model="ruleForm.data_type"
            style="width: 100%"
            placeholder=" "
          >
            <el-option
              :label="item.name"
              :value="item.value"
              v-for="(item, index) in dictList"
              :key="index"
            ></el-option>
          </el-select>
        </el-form-item>
        <el-form-item label="字典名称" prop="name" :rules="btRules">
          <el-input v-model="ruleForm.name" placeholder=" "></el-input>
        </el-form-item>
        <el-form-item label="排序" prop="sort_order" :rules="btRules">
          <el-input-number
            v-model="ruleForm.sort_order"
            style="width: 100%"
            :min="1"
            :step="1"
            :controls="false"
            step-strictly
          ></el-input-number>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="handleSure">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  index_class,
  delete_class,
  add_class,
  update_class,
} from "../../axios/api";
export default {
  data() {
    return {
      data_type: null,
      btRules: [
        { required: true, message: "必填", trigger: ["blur", "change"] },
      ],
      dialogVisible: false,
      title: "新增字典",
      ruleForm: {},
      tableData: [],
      curTableData: [],
      dictList: [
        {
          name: "曾担任评委",
          value: 10,
        },
        {
          name: "行业领域",
          value: 11,
        },
      ],
    };
  },
  mounted() {
    this.getList();
  },
  methods: {
    handleQuery() {
      if (this.data_type) {
        this.curTableData = this.tableData.filter(
          (item) => item.data_type === this.data_type
        );
      } else {
        this.curTableData = JSON.parse(JSON.stringify(this.tableData));
      }
    },
    handleAdd() {
      this.ruleForm = {
        data_type: null,
        name: null,
        sort_order: 1,
      };
      this.title = "新增字典";
      this.dialogVisible = true;
      this.$nextTick(() => {
        this.$refs.ruleForm.clearValidate()
      })
    },
    handleEdit(row) {
      this.title = "编辑字典";
      this.ruleForm = { ...row };
      this.dialogVisible = true;
    },
    handleSure() {
      this.$refs.ruleForm.validate((valid) => {
        if (valid) {
          let reqFun = null;
          reqFun = this.ruleForm.id ? update_class : add_class;
          reqFun({
            ...this.ruleForm,
            token: sessionStorage.getItem("Token3"),
          }).then((res) => {
            if (res.data.code === 200) {
              this.$message({
                message: "新增成功",
                type: "success",
              });
              this.getList();
              this.dialogVisible = false;
            }
          });
        } else {
          console.log("error submit!!");
          this.$message({
            message: "请填写完必填项",
            type: "error",
          });
          return false;
        }
      });
    },
    handleClose() {
      this.dialogVisible = false;
    },
    formatDict(row) {
      let obj = this.dictList.find((item) => item.value === row.data_type);
      return obj?.name;
    },
    handleDel(row) {
      delete_class({
        token: sessionStorage.getItem("Token3"),
        id: row.id,
      }).then((res) => {
        if (res.data.code === 200) {
          this.$message({
            message: "删除成功",
            type: "success",
          });
          this.getList();
        }
      });
    },
    getList() {
      index_class({ token: sessionStorage.getItem("Token3") }).then((res) => {
        if (res.data.code === 200) {
          this.tableData = [];
          Object.keys(res.data.data.types).forEach((attr) => {
            this.tableData = this.tableData.concat(res.data.data.types[attr]);
          });
          this.curTableData = JSON.parse(JSON.stringify(this.tableData));
        }
      });
    },
  },
};
</script>

<style lang="less" scoped>
.dict {
  width: 100%;
  height: 100%;
  background-color: #fff;
  overflow: hidden;
  position: relative;
  box-sizing: border-box;
  .cjh-title {
    padding: 20px 25px;
    border-bottom: 1px solid rgba(220, 220, 220, 0.5);
    font-weight: 600;
    font-size: 20px;
  }
  .btn-warp {
    display: flex;
    justify-content: space-between;
    margin-bottom: 20px;
  }
}
</style>
